import { useEffect, useState } from 'react'

const formatDate = (timeZone?: string): string => {
  try {
    return new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      ...(timeZone ? { timeZone } : {}),
    }).format(new Date())
  } catch {
    return new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(new Date())
  }
}

/**
 * Publication date shown to the reader, localized to the visitor's own
 * location. We resolve the timezone from the visitor's IP and fall back to the
 * browser timezone if the lookup is unavailable.
 */
export function useVisitorDate(): string {
  const [date, setDate] = useState<string>(() => formatDate())

  useEffect(() => {
    let cancelled = false

    const resolve = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/')
        if (!response.ok) return
        const data: { timezone?: string } = await response.json()
        if (!cancelled && data.timezone) {
          setDate(formatDate(data.timezone))
        }
      } catch {
        // Keep the browser-local date.
      }
    }

    resolve()
    return () => {
      cancelled = true
    }
  }, [])

  return date
}
